<template>
  <div
    v-if="hasBicycleDetails"
    data-testid="bicycle-details-section"
    class="rounded-lg border border-secondary-300 bg-secondary-100 p-4"
  >
    <h4
      class="text-sm font-medium text-secondary-800 mb-3 flex items-center gap-2"
    >
      <svg
        data-testid="info-icon"
        class="h-4 w-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        ></path>
      </svg>
      Productinformatie
    </h4>
    <div class="text-sm text-secondary-800 space-y-1">
      <pre
        class="whitespace-pre-wrap font-mono text-xs bg-white p-3 rounded border border-neutral-200"
        >{{ JSON.stringify(bicycleDetails, null, 2) }}</pre
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface BicycleDetailsShape {
  sku?: string | null;
  model?: string | null;
  [key: string]: unknown;
}

interface Props {
  bicycleDetails?: BicycleDetailsShape;
}

const props = defineProps<Props>();

// Only show when both sku and model are non-null / non-undefined
const hasBicycleDetails = computed(() => {
  const d = props.bicycleDetails;
  if (!d) return false;
  return d.sku != null && d.model != null; // allows empty string but hides when null/undefined
});
</script>
